"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    activity: {
      display: 'flex',
      marginBottom: theme.spacing(4),
      '&:last-child': {
        marginBottom: theme.spacing(0)
      }
    },
    user: {
      color: theme.palette.NEUTRAL500,
      fontSize: theme.typography.pxToRem(14),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightMedium
    },
    message: {
      color: theme.palette.NEUTRAL200,
      fontSize: theme.typography.pxToRem(14),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightRegular,
      marginBottom: theme.spacing(0.5)
    },
    date: {
      color: theme.palette.NEUTRAL200,
      fontSize: theme.typography.pxToRem(12),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightRegular
    }
  });
});
var _default = useStyles;
exports.default = _default;